import Cookies from "js-cookie";

interface GetGoogleAuthTokensResult {
    idToken: string | null;
    accessToken: string | null;
}

/**
 * Retrieves Google auth tokens from localStorage (primary) or cookies (fallback).
 * Used to handle Safari privacy protection blocking cookies.
 * When cookies are blocked, tokens are stored in localStorage by the HTML page.
 */
export function getGoogleAuthTokens(): GetGoogleAuthTokensResult {
    const idToken = localStorage.getItem("google_auth_id_token");
    const accessToken = localStorage.getItem("google_auth_access_token");

    if (idToken) {
        localStorage.removeItem("google_auth_id_token");
    }
    if (accessToken) {
        localStorage.removeItem("google_auth_access_token");
    }

    return { idToken, accessToken };
}

